/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MealTypeView
 */
export interface MealTypeView {
    /**
     * 
     * @type {string}
     * @memberof MealTypeView
     */
    code: string;
}

/**
 * Check if a given object implements the MealTypeView interface.
 */
export function instanceOfMealTypeView(value: object): value is MealTypeView {
    if (!('code' in value) || value['code'] === undefined) return false;
    return true;
}

export function MealTypeViewFromJSON(json: any): MealTypeView {
    return MealTypeViewFromJSONTyped(json, false);
}

export function MealTypeViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): MealTypeView {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

  export function MealTypeViewToJSON(json: any): MealTypeView {
      return MealTypeViewToJSONTyped(json, false);
  }

  export function MealTypeViewToJSONTyped(value?: MealTypeView | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
    };
}

